import { QuestionType } from "@/models/survey/questionType";
import QuestionViewModel from "@/models/survey/questionViewModel";
import SaveSurveyDto from "@/models/survey/saveSurveyDto";
import { SurveyType } from "@/models/survey/surveyType";
import { SurveyService } from "@/services/surveys/surveyService";

export const surveyStore = {
     namespaced: true,
   
     state: {
     },
   
     getters: {
     },
   
     mutations: {
     },
   
     actions: {
       async saveSurvey({ commit }: any, questions: QuestionViewModel[]) : Promise<void> {

          const surveyData = {
               questions: questions.map((question) => {
                    return {
                         text: question.text,
                         type: mapInputTypeToQuestionType(question.type).toString(),
                         // TODO: When multiselect is implemented, this will need to be updated
                         answer: question.answer
                    }
               })
          }

          const saveSurveyDto: SaveSurveyDto = {
               type: SurveyType.Waitlist,
               surveyData: JSON.stringify(surveyData)
          };

          await SurveyService.saveSurvey(saveSurveyDto);
       },
     },
};

const mapInputTypeToQuestionType = (inputType: string): QuestionType => {
     switch (inputType) {
          case 'radio':
               return QuestionType.SingleChoice;
          case 'checkbox':
               return QuestionType.MultipleChoice;
          case 'date':
          case 'text':
          case 'number':
          default:
               return QuestionType.Text;
     }
}